<template>
  <div class="advantage" v-lazy>
    <div class="title">为什么<span>选意刻</span></div>
    <Card class="shadow-2 section1">
      <template #content>
        <div class="left">
          <div class="tip">覆盖更全</div>
          <div class="title">千万题库，涵盖所有<br />冷门分类内容</div>
          <div class="desc">
            千万题库数据，来自各个平台搜集并处理，不论是已出版的书籍的课后习题还是单独出的试卷，都经过精确效验后入库存储，只为给你最准确的答案！
          </div>
          <router-link :to="{ name: 'Login' }" class="btn btn-linear"
            >免费使用千万题库-></router-link
          >
        </div>
        <div class="right">
          <img src="http://img.mmifx.com/blog/pic202204301927580.png" alt="" />
        </div>
      </template>
    </Card>
    <div class="others" v-lazy>
      <Card class="shadow-2 tools1">
        <template #content>
          <div class="content">
            <div class="tip">工具优势</div>
            <div class="title">
              多种主流文件导入格式，没有<br />
              的题等你来提!
            </div>
            <div class="desc">
              没有要搜的题目？没关系，我们支持多种文件导入，包括但不限于sql,excel,word等...
            </div>
            <div class="icons"></div>
          </div>
          <div class="img">
            <img
              src="http://img.mmifx.com/blog/pic202204301927580.png"
              alt=""
            />
          </div>
        </template>
      </Card>
      <div class="tools2">
        <Card class="shadow-2 item">
          <template slot="content">
            <div class="title">跨平台支持</div>
            <div class="desc">一个账号可以在网站、小程序、API同时调用...</div>
            <div class="img">
              <img src="http://img.mmifx.com/blog/pic202204301927580.png" alt="" />
            </div>
          </template>
        </Card>
        <Card class="shadow-2 item">
          <template slot="content">
            <div class="title">数据统计</div>
            <div class="desc">完善且详尽的数据统计</div>
            <div class="img">
              <img v-lazy data-src="http://img.mmifx.com/blog/pic202204301927580.png" alt="" />
            </div>
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "@/components/common/Card";
export default {
  components: {
    Card,
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="less" scoped>
.advantage {
  .title {
    margin: 100px 0;
    text-align: center;
    font-size: 60px;
    width: 100%;
    font-weight: 700;
    font-family: Cambria, Cochin, Georgia, Times, "Times New Roman", serif;
    color: rgba(0, 0, 0, 0.6);
    span {
      color: #000;
    }
  }
  .card.section1 {
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    width: 1346px;
    margin: 1rem auto;
    .left {
      padding-left: 50px;
      padding-top: 80px;
      position: relative;
      width: 40%;
      .tip {
        color: #009dff;
        font-weight: 700;
        font-family: "微软雅黑";
        font-size: 24px;
      }
      .title {
        color: #000;
        font-size: 40px;
        font-weight: 600;
        margin: 0;
        margin-top: 30px;
        text-align: left;
      }
      .desc {
        margin-top: 50px;
        color: rgba(0, 0, 0, 0.6);
        font-size: 18px;
        width: 80%;
      }
      .btn-linear {
        position: absolute;
        bottom: 40px;
        left: 50px;
        padding: 10px 30px;
        font-size: 20px;
        display: inline-block;
        border: solid 2px #000;
        border-radius: 30px;
        cursor: pointer;
        transition: all 0.3s ease-in-out;
        &:hover {
          background: #009dff;
          border: solid 2px #009dff;
          color: #fff;
        }
      }
    }
    .right {
      width: 60%;
      background: url("https://img.js.design/assets/Resources/background/home-bg-2.png")
        center top / 165% no-repeat fixed;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 70%;
        height: 70%;
        border-radius: 10px;
      }
    }
  }
  .others {
    display: flex;
    width: 1346px;
    margin: 2rem auto;
    height: auto;
    justify-content: space-between;
    .tools1 {
      width: 60%;
      display: flex;
      flex-direction: column;
      .content {
        display: flex;
        flex-direction: column;
        padding: 2rem 0 0 2rem;
        .tip {
          color: #009dff;
          font-weight: 700;
          font-family: "微软雅黑";
          font-size: 24px;
        }
        .title {
          color: #000;
          font-size: 40px;
          font-weight: 600;
          margin: 0;
          margin-top: 30px;
          text-align: left;
        }
        .desc {
          margin-top: 50px;
          color: rgba(0, 0, 0, 0.6);
          font-size: 18px;
          width: 80%;
        }
      }
      .img {
        width: 100%;
        height: 400px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 10px;
        }
      }
    }
    .tools2 {
      width: 39%;
      display: flex;
      flex-direction: column;
      .item {
        height: 50%;
        padding: 2rem;
        display: flex;
        flex-direction: column;
        position: relative;
        .title {
          margin: 0;
          font-size: 24px;
          font-weight: 700;
          text-align: left;
          color: #009dff;
        }
        .desc {
          font-size: 18px;
          margin-top: 30px;
          color: rgba(0, 0, 0, 0.6);
        }
        .img {
          position: absolute;
          bottom: 1rem;
          left: 1rem;
          right: 1rem;
          height: 200px;
        }
      }
    }
  }
}
</style>
